<template>
  <div class="icon-process-wrapper">
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-fire"></i>
        </div>
        <h5 class="icon-process-single__title">Define your audience</h5>
        <div class="icon-process-single__text">
          First you need to pinpoint the typical stakeholders involved in your business.
        </div>
      </div>
    </div>
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-users"></i>
        </div>
        <h5 class="icon-process-single__title">Set the configuration type</h5>
        <div class="icon-process-single__text">
          Define what type of campaign you need, do you want to widen your network with new
          connections?
          or discover new opportunities by starting new conversations with your 1st-degree network?
        </div>
      </div>
    </div>
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-chart-line"></i>
        </div>
        <h5 class="icon-process-single__title">Increase your growth</h5>
        <div class="icon-process-single__text">
          YourSynchronicity will run for you the configuration type, allowing you to focus only on
          the things that matter for your business.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Gradation',
    };
</script>
